import Constants from "../shared/constants/environmentConfig";

const constants = Constants();

export const isMobileDevice = () => {
  return (
    typeof window.orientation !== "undefined" ||
    navigator.userAgent.indexOf("IEMobile") !== -1
  );
};

export const getHomeDomain = () => {
  const protocolScheme = constants.cookie.secure ? "https://" : "http://";
  return protocolScheme + constants.cookie.homeDomain;
};


export const formatPhoneNumber = (phoneNumberString) => {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return match[1] + '-' + match[2] + '-' + match[3]
  }
  return ''
}

export const isPu = () => {
  const host = window.location.host;
  const parts = host.split(".");
  return parts[0].includes("pu");
};

export const isNeet = () => {
  const host = window.location.host;
  const parts = host.split(".");
  return parts[0].includes("neet");
};

export const validateEmail = (email) => {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return !(email.length < 6 || !emailRegex.test(email));
};

export const validateNumberInput = (input) => {
  return input.match(/[0-9]/g) ? input.match(/[0-9]/g).join("") : "";
};

export const validateNoSpaceInput = (input) => {
  const csvRegex = /\s/g;
  return !csvRegex.test(input);
};

export const getAccountsDomain = () => {
  const protocolScheme = constants.cookie.secure ? "https://" : "http://";
  return protocolScheme + constants.cookie.accountsDomain;
};

export const convertToCurrencyFormat = (num, currency = "₹ ") => {
  return (currency + num).replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
};

export const toTitleCase = (text) => {
  return text
    .split(" ")
    .map((word) => word[0].toUpperCase() + word.substr(1).toLowerCase())
    .join(" ");
};

export const isToday = (dateString) => {
  const today = new Date();
  const someDate = new Date(dateString);
  return (
    someDate.getDate() == today.getDate() &&
    someDate.getMonth() == today.getMonth() &&
    someDate.getFullYear() == today.getFullYear()
  );
};

export const addDashesToPhoneNumber = (phoneNumber) => {
  phoneNumber = phoneNumber.replace(/\D[^\.]/g, "");
  return (
    phoneNumber.slice(0, 3) +
    "-" +
    phoneNumber.slice(3, 6) +
    "-" +
    phoneNumber.slice(6)
  );
};

export const SIDE_PADDING =
  window.innerWidth <= 768
    ? 24
    : window.innerWidth <= 1150
    ? 60
    : window.innerWidth <= 1250
    ? 80
    : 150;

export const INNER_PADDING = 30;

export const KARNATAKA_NUMBER = "080 471 85111";
